import React, { useEffect, useState } from 'react'

import { Typography, Row } from 'antd'
import { ResponsiveContainer, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList } from 'recharts'

import EmptyData from '../../../../assets/images/ico_dashboard.svg'

import './styles.css'

import { api } from '../../../../util/handlerRequestUtil'

export const EibActionsByCategory = ({ filter }) => {
  const [eibActionsByCategory, setEibActionsByCategory] = useState([])
  const [eibCategory, setEibCategory] = useState({})

  useEffect(() => {
    if (filter.safra_id) {
      loadEibActionsByCategory(filter)
    }

    if (filter.categoria_de_acao_id > 0) {
      getCategoryById(filter.categoria_de_acao_id)
    }
  }, [filter])

  async function getCategoryById(categoryId) {
    const response = await api.getCategory(categoryId)
    setEibCategory(response)
  }

  async function loadEibActionsByCategory(filter) {
    const response = await api.getMonitoringOfActionsByCategory(filter)
    setEibActionsByCategory(response)
  }

  if (eibActionsByCategory && eibActionsByCategory.length > 0) {
    return (
      <Row gutter={[16, 16]} style={{ fontSize: 11, color: '#8591A1' }}>
        <h3 style={{ fontSize: 14, fontWeight: 500, color: ' #263447', marginBottom: 4 }}>
          {eibCategory.id > 0
            ? `Acompanhamento de Ações da Categoria: ${eibCategory.name}`
            : 'Acompanhamento de ações por categoria'}
        </h3>
        <ResponsiveContainer width="99%" height="95%" aspect={1.2}>
          <BarChart barSize={20} layout="vertical" data={eibActionsByCategory}>
            <Legend verticalAlign="top" align="right" height={25} />
            <XAxis type="number" tickCount={22} allowDecimals={false} />
            <YAxis dataKey="name" width={100} tickLine={false} type="category" />
            <CartesianGrid stroke="#ccc" horizontal={false} />
            <Tooltip />
            <Bar dataKey="Planejadas" fill="#B58BFA">
              <LabelList dataKey="Planejadas" position="right" style={{ fill: '#B58BFA' }} />
            </Bar>
            <Bar dataKey="Executadas" fill="#04D1D1">
              <LabelList dataKey="Executadas" position="right" style={{ fill: '#04D1D1' }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Row>
    )
  } else {
    return (
      <div style={{ width: '100%' }}>
        <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: '57vh', background: '#F1F3F5' }}>
          <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
          <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 18 }}>
            {'Sem dados'}
          </Typography>
          <Typography
            style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -50 }}
          >
            {'Aplique ou altere o filtro para'}
          </Typography>
          <Typography
            style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -120 }}
          >
            {'exibir dados.'}
          </Typography>
        </div>
      </div>
    )
  }
}
